export default __webpack_public_path__ + "static/media/icon_user.46e01dc7.svg";